// extracted by mini-css-extract-plugin
module.exports = {"cover":"_536c1483","noPicture":"_70a31fa3","details":"_e2fd024c","tabsWrapper":"_2cfd0519","top":"_4e9ec9e5","headshot":"_f2bbc246","follow":"_67f45fff","profileCover":"_a58467a8"};